// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NNNt","type":"styles_type__3euDI","choices":"styles_choices__1SDKo"};